import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Anonymous, SparkleStar } from '@peacecover/icon';

interface ThreadContentItemProps {
  speaker?: string;
  threadType: string;
  text: string;
  className?: string;
  hasLine?: boolean;
  showStar?: boolean;
  backgroundColor?: string;
}

const ThreadContentItem = ({
  speaker,
  threadType,
  text,
  className,
  hasLine = true,
  showStar = false,
  backgroundColor = '#4B34B8'
}: ThreadContentItemProps) => {
  const { t } = useTranslation();
  switch (threadType) {
    case 'passage':
      return (
        <div className={`px-[24px] pb-[24px] ${className}`}>
          <div
            className="text-[16px] leading-[28px] text-white break-keep whitespace-pre-line"
            style={{
              fontFamily: '"Noto Serif KR", ui-serif, Georgia, "Times New Roman", serif',
              letterSpacing: '3.4%'
            }}
          >
            {text}
          </div>
        </div>
      );
    case 'thread':
      return (
        <div className={`px-[22px] py-[15px] flex gap-[10px] items-stretch ${className}`}>
          <div className="flex flex-col items-center gap-[8px]">
            <div
              className="rounded-full w-[26px] h-[26px] flex items-center justify-center relative flex-shrink-0"
              style={{ backgroundColor }}
            >
              <Anonymous size={22} className="text-white absolute left-[1.6px] top-[1.6px]" />
            </div>
            {hasLine && (
              <div className="w-[2px] flex-1 mb-[-20px] rounded-[16px] bg-[rgba(255,255,255,0.13)]" />
            )}
          </div>
          <div className="flex flex-col items-start gap-[5px] flex-1">
            <p className="m-0 text-[14px] font-semibold leading-[17px] text-separator-light-1">
              {speaker ?? t('SceneMain.anonymous')}
            </p>
            <p className="m-0 text-[16px] leading-[20px] text-pure-white relative whitespace-pre-line">
              {text}
              <motion.div
                className="absolute bottom-[-12px] right-[2px] pointer-events-none"
                initial={{ opacity: 0 }}
                animate={{ opacity: showStar ? 1 : 0 }}
                transition={{ duration: 0.4, ease: 'easeInOut' }}
                aria-hidden={!showStar}
              >
                <SparkleStar
                  size={11}
                  className="absolute bottom-[3px] right-[-1px]"
                  gradientStops={[
                    { offset: '-11%', color: '#45E0AD' },
                    { offset: '100%', color: '#5C3DFA' }
                  ]}
                />
                <SparkleStar
                  size={7}
                  className="absolute bottom-[13px] right-[-8px]"
                  gradientStops={[
                    { offset: '-11%', color: '#45E0AD' },
                    { offset: '100%', color: '#5C3DFA' }
                  ]}
                />
              </motion.div>
            </p>
          </div>
        </div>
      );
  }
};

export default ThreadContentItem;
